import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import Status, {
  ASStatus,
} from 'scenes/CustomAudiences/Audiences/components/Status';

const Metadata = ({ data }) => {
  return (
    <DescriptionList
      variant={'column'}
      data={data}
      stripEmpty={true}
      disableGutters={true}
    >
      <DescriptionItem
        label={'Status'}
        field={'filterStatus'}
        type={({ value }) => <Status id={value.id}>{value.name}</Status>}
      />
      <DescriptionItem
        label={'Size'}
        field={'size'}
        type={'decimal'}
        textVariant={'h6'}
      />
      <DescriptionItem
        label={'ATT excluded size'}
        field={'attExcludedSize'}
        type={'decimal'}
        textVariant={'h6'}
      />
      <DescriptionItem
        label={'Auto update'}
        field={'autoSync'}
        type={({ value }) => <ASStatus isOn={value} />}
      />
      <DescriptionItem
        label={'Last list update'}
        field={'lastSyncDate'}
        type={'date'}
        template={'LL'}
        timeZone={'utc'}
      />
      <DescriptionItem label={'Owner'} field={'owner.name'} />
      <DescriptionItem
        label={'Last updated by'}
        type={'metadata'}
        field={'updated'}
      />
      <DescriptionItem
        label={'Created by'}
        type={'metadata'}
        field={'created'}
      />
    </DescriptionList>
  );
};

export default Metadata;
